export default __webpack_public_path__ + "static/media/add-charcter.52fcf584.webp";